module.exports = __webpack_public_path__ + "static/impressum-4bc76d3faeffb9864bc5be6706ac82fe.jpg";